import { NavLink, useNavigate } from 'react-router-dom';
import React, {useState, useEffect } from 'react';


import '@fortawesome/fontawesome-free/css/all.min.css';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const Launchpad = () => {
	const navigate = useNavigate();
	const [launchpadData, setCoins] = useState([]);
  	const [loading, setLoading] = useState(true);
  	const [error, setError] = useState(null);
  	const [totalPages, setTotalPages] = useState(0);
  	const [currentPage, setCurrentPage] = useState(1);
		const [skeletoncard, setSkeletonCard] = useState(true);

  	const pagesToShow = 5;
  	const startPage = Math.max(1, currentPage);
  	const endPage = Math.min(totalPages, startPage + pagesToShow - 1);

  	const handlePageChange = (page: number) => {
	  if (page >= 1 && page <= totalPages) {
	    setCurrentPage(page);
	  }
	};

  	const [searchTerm, setSearchTerm] = useState('');

	const filteredData = launchpadData.filter((coin) =>
	  coin.name.toLowerCase().includes(searchTerm.toLowerCase())
	);

  useEffect(() => {
    const fetchlaunchpad = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/get-launchpad-data?page_number=${currentPage}`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch Launchpad data (status ${response.status})`);
        }
        
        const data = await response.json();
        
        if (data.error) {
          throw new Error(data.error);
        }
        
        // setCoins(data);
        setCoins(data.resluts);
        setTotalPages(data.total_pages);
		setSkeletonCard(false);
        setError(null);
      } catch (err) {
        console.error('Error fetching Launchpad data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchlaunchpad();
  }, [currentPage]);

return (

<div className="launchpad_wrapper">
	<div className="launchpad_mainsec">
		<div className="container">
			<div className="row">
				<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
					<div className="toptitle_sec">
					{!skeletoncard && (
						<>
						<h1>Discover Crypto Launchpad</h1>
						<p>Find the latest Launchpad from across the crypto ecosystem in one place. Track active and upcoming opportunities to earn free tokens. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
						</>
					)}
						{skeletoncard && (
							<div className="skeleton-card">
								<div className="skeleton skeleton-title"></div>
								<div className="skeleton skeleton-text"></div>
								<div className="skeleton skeleton-text"></div>
								<div className="skeleton skeleton-text"></div>
								<div className="skeleton skeleton-text"></div>
								<div className="skeleton skeleton-text"></div>
							</div>
						)}
					</div>
				</div>
			</div>
			
			<div className="row" style={{ display: `none` }}>
				<div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
					<div className="value_infobox">
						<div className="box_mainsec">
							<div className="contntbox">
								<h4>Total Active</h4>
								<p>4</p>
							</div>
							
							<div className="iconbox">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check-circle2 h-5 w-5 text-emerald-500"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
					<div className="value_infobox">
						<div className="box_mainsec">
							<div className="contntbox">
								<h4>Upcoming</h4>
								<p>3</p>
							</div>
							
							<div className="iconbox">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-clock h-5 w-5 text-blue-500"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
					<div className="value_infobox">
						<div className="box_mainsec">
							<div className="contntbox">
								<h4>Ended</h4>
								<p>1</p>
							</div>
							
							<div className="iconbox">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-circle h-5 w-5 text-red-500"><circle cx="12" cy="12" r="10"></circle></svg>
							</div>
						</div>
					</div>
				</div>
				
				<div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
					<div className="value_infobox">
						<div className="box_mainsec">
							<div className="contntbox">
								<h4>Total Value</h4>
								<p>$10,000+</p>
							</div>
							
							<div className="iconbox">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-trending-up h-5 w-5 text-purple-500"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div className="row">
				<div className="available_airdrops_box">
					<div className="row">
						<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						{!skeletoncard && (
							<div className="title_box">
								<h1>Available Launchpad</h1>
							</div>
						)}
							
							{skeletoncard && (
								<div className="skeleton-card">
									<div className="title_box">
										<div className="skeleton skeleton-title"></div>
									</div>
								</div>
							)}
						</div>
					</div>
					
					<div className="row">
						<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						{!skeletoncard && (
							<div className="search_airdrops">
								<div className="search_box">
									<input type="text" className="inputbox" placeholder="Search Launchpad..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
								</div>
								
								{/*<div className="btn_box">
									<button className="filter_btn">
										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-sliders-horizontal h-4 w-4 mr-2"><line x1="21" x2="14" y1="4" y2="4"></line><line x1="10" x2="3" y1="4" y2="4"></line><line x1="21" x2="12" y1="12" y2="12"></line><line x1="8" x2="3" y1="12" y2="12"></line><line x1="21" x2="16" y1="20" y2="20"></line><line x1="12" x2="3" y1="20" y2="20"></line><line x1="14" x2="14" y1="2" y2="6"></line><line x1="8" x2="8" y1="10" y2="14"></line><line x1="16" x2="16" y1="18" y2="22"></line></svg>
										
										<span>Filters</span>
									</button>
									
									<div className="selectbox">
										<select>
											<option>Newest</option>
											<option>Ending Soon</option>
											<option>Highest Value</option>
										</select>
									</div>
								</div>*/}
							</div>
						)}
							{skeletoncard && (
								<div className="skeleton-card">
									<div className="search_airdrops">
										<div className="search_box">
											<div className="skeleton skeleton-thumbnail"></div>
										</div>
										
										{/*<div className="btn_box">
											<div className="skeleton skeleton-title"></div>
											
											<div className="skeleton skeleton-title"></div>
										</div>*/}
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
			
			<div className="row">
				<div className="airdrops_mainsec">
					<div className="row">

					{skeletoncard && (
						<>
						{[...Array(4)].map((_, i) => (
							<div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
								<div className="skeleton-card">
									<div className="airdrops_boxsec">
										<div className="imgbox">
											<div className="skeleton skeleton-thumbnail"></div>
										</div>
										
										<div className="contntbox">
											<div className="titlebox">
												<div className="skeleton skeleton-title"></div>
												
												<div className="statusbox">
													<div className="skeleton skeleton-text"></div>
												</div>
											</div>
											
											<div className="date_value_sec">
												<div className="boxsec">
													<div className="skeleton skeleton-small-text"></div>
													<div className="skeleton skeleton-small-text"></div>
													<div className="skeleton skeleton-small-text"></div>
													<div className="skeleton skeleton-small-text"></div>
													<div className="skeleton skeleton-small-text"></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						))}
						</>
					)}

					{filteredData.map((coin, index) => (
						<div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
							<div className="airdrops_boxsec">
								<div className="imgbox">
									<img alt="Crypto News Image" src={coin.image} />
								</div>
								
								<div className="contntbox">
									<div className="titlebox">
										<h3 style={{ cursor: "pointer" }} onClick={() => navigate(`/coin/${coin.id}`)}>{coin.name}</h3>
										
										<div className="statusbox">
											<span className="active">
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check-circle2 w-3 h-3 mr-1"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>
												
												{coin.symbol}
											</span>
										</div>
									</div>
									
									<div className="date_value_sec">
										<div className="boxsec">
											<span className={`updown_txt ${
				                              coin?.current_price >= 0 
				                                ? "upcoin" 
				                                : "downcoin"
				                            }`}
				                          >
                        {coin?.current_price >= 0 ? (
                          <i className="fas fa-caret-up"></i>
                        ) : (
                          <i className="fas fa-caret-down"></i>
                        )}
                        
                      </span>
											<span className={`updown_txt ${coin.current_price >= 0 ? 'upcoin' : 'downcoin'}`}>${coin.current_price?.toLocaleString()}
											</span>
										</div>
										
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
											
											<span>Market Cap : ${coin.market_cap?.toLocaleString()}</span>
										</div>
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
											
											<span>Rank : ${coin.market_cap_rank?.toLocaleString()}</span>
										</div>
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
											
											<span>Volume : ${coin.total_volume?.toLocaleString()}</span>
										</div>
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
											
											<span>Max Supply : ${coin.max_supply?.toLocaleString()}</span>
										</div>
									</div>
									
								</div>
							</div>
							
							
						</div>
					))}	
						
					<div className="flex items-center space-x-1 pagination_box">
	                    <button
	                      onClick={() => handlePageChange(currentPage - 1)}
	                      disabled={currentPage === 1}
	                      className="w-8 h-8 flex items-center justify-center rounded-md border border-gray-300 text-gray-500 disabled:opacity-50 previous_btn"
	                    >
	                      <i className="fas fa-arrow-left"></i>
	                    </button>

	                    {/* Dynamic Page Numbers */}
	                    {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
	                      <button
	                        key={page}
	                        onClick={() => handlePageChange(page)}
	                        className={`w-8 h-8 flex items-center justify-center rounded-md ${
	                          currentPage === page ? "bg-blue-600 text-white" : "border border-gray-300 text-gray-700"
	                        }`}
	                      >
	                        {page}
	                      </button>
	                    ))}

	                    {/* Next Button */}
	                    <button
	                      onClick={() => handlePageChange(currentPage + 1)}
	                      disabled={currentPage === totalPages}
	                      className="w-8 h-8 flex items-center justify-center rounded-md border border-gray-300 text-gray-500 disabled:opacity-50 next_btn"
	                    >
	                      <i className="fas fa-arrow-right"></i>
	                    </button>
	                  </div>	
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

);
};

export default Launchpad;